"use client";

import { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import ProductImage from "@/app/ec/product/productImage";
import type { PendingReviewLineItemVO } from "@/store/vendorApi";
import Link from "next/link";
import { FunctionComponent } from "react";
import styles from "./vendorOrderItemsDrawer.module.scss";

export interface VendorOrderItemsMenuProps extends OverlayMenuBaseProps {
  vendorName: string;
  items: PendingReviewLineItemVO[];
}

/** Body content for the vendor “all order line items” overlay menu (header/close shell is `DrawerMenu`). */
const VendorOrderItemsMenu: FunctionComponent<VendorOrderItemsMenuProps> = ({ items }) => {
  return (
    <div className={styles.menuBody}>
      {items.map((item, index) => {
        const rowKey =
          item.oliId != null ? `voi-${item.oliId}` : `voi-${item.vpId ?? "vp"}-${item.mpId ?? "mp"}-${index}`;
        const displayName = item.mpName?.trim() || "Product";
        const productHref =
          item.productDetailLink != null && item.productDetailLink !== "" ? `/${item.productDetailLink}` : "#";

        return (
          <div key={rowKey} className={styles.row}>
            <Link href={productHref} className={styles.rowImageLink} prefetch={false}>
              <ProductImage
                className={styles.rowImage}
                src={`/media/${item.smallPhotoPath}`}
                alt={displayName}
                width={64}
                height={64}
                sizes="64px"
              />
            </Link>
            <div className={styles.rowTitleWrap}>
              <Link href={productHref} className={styles.rowTitleLink} prefetch={false}>
                {displayName}
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VendorOrderItemsMenu;
